import { useState } from 'react'
import classes from './SharedFilters.module.scss'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'

const SharedFilters = ({ filters, onFilterChange, priceRange, setPriceRange }) => {
  const [sliderValues, setSliderValues] = useState([0, 400])
  const minPrice = 0
  const maxPrice = 400

  const handleSliderChange = (values) => {
    setSliderValues(values)
  }

  const handleSliderAfterChange = (values) => {
    setPriceRange({
      min: values[0],
      max: values[1]
    })
  }

  return (
    <div className={classes.filters}>
      <div className={classes.checkboxes}>
        <label className={classes.checkbox}>
          <input
            type="checkbox"
            checked={filters.onSale}
            onChange={() => onFilterChange('onSale')}
          />
          On Sale
        </label>
        <label className={classes.checkbox}>
          <input
            type="checkbox"
            checked={filters.valueBoxes}
            onChange={() => onFilterChange('valueBoxes')}
          />
          Value Boxes
        </label>
      </div>

      <div className={classes.priceRange}>
        <h2 className={classes.sidebarTitle}>Price Range</h2>
        <div className={classes.sliderContainer}>
          <div className={classes.priceLabels}>
            <span>${minPrice}</span>
            <span>${maxPrice}</span>
          </div>
          <Slider
            range
            min={minPrice}
            max={maxPrice}
            value={sliderValues}
            onChange={handleSliderChange}
            onAfterChange={handleSliderAfterChange}
            railStyle={{ backgroundColor: '#E5E5E5' }}
            trackStyle={[{ backgroundColor: '#1A507F' }]}
            handleStyle={[
              {
                backgroundColor: '#1A507F',
                border: 'none',
                boxShadow: 'none',
                opacity: 1,
                width: 20,
                height: 20,
                marginTop: -8,
              },
              {
                backgroundColor: '#1A507F',
                border: 'none',
                boxShadow: 'none',
                opacity: 1,
                width: 20,
                height: 20,
                marginTop: -8,
              },
            ]}
          />
          <div className={classes.selectedPrices}>
            <span>${sliderValues[0]}</span>
            <span>${sliderValues[1]}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SharedFilters